<template>
    <PageLoading :loading="loading">
        <!-- 错误页面 -->
        <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />
        <div v-else class="face-purchase-page">
            <!-- 刷脸购买说明 -->
            <div class="instructions-section">
                <div class="section-title">刷脸购买说明</div>
                <div class="instructions-list">
                    <div class="instruction-item" v-for="(item,index) in faceNotice.split('\n')" :key="index">
                        <!-- <van-icon name="info" class="instruction-icon info" /> -->
                        <div class="instruction-text">
                            {{ item }}
                        </div>
                    </div>
                    <!-- <div class="instruction-item">
                        <van-icon name="clock" class="instruction-icon clock" />
                        <div class="instruction-text">
                            2. 售货机服务时间:周一至周五07:00-18:00
                        </div>
                    </div>
                    <div class="instruction-item">
                        <van-icon name="location" class="instruction-icon location" />
                        <div class="instruction-text">
                            3. 售货机位置:教学楼一层、二层、食堂等区域
                        </div>
                    </div>
                    <div class="instruction-item">
                        <van-icon name="card" class="instruction-icon payment" />
                        <div class="instruction-text">
                            4. 支持余额支付、微信支付等多种支付方式
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- 学生列表 -->
            <div class="students-section">
                <div class="section-header">
                    <div class="section-title">学生列表</div>
                    <van-button type="primary" class="add-student-btn" plain @click="addStudent"
                        icon="plus">新增学生</van-button>
                </div>

                <div class="students-list">
                    <div class="student-item" v-for="student in students" :key="student.id">
                        <div class="student-avatar">
                            <van-image :src="Object.keys(student.face_image_arr || {}).length > 0 ? student.face_image_arr.face_image_url : userDefaultImage" round fit="cover" class="student-avatar-img" />
                        </div>
                        <div class="student-info">
                            <div class="student-name">{{ student.name }}</div>
                            <div class="student-class">{{ student.school_name }} {{ student.grade_name }} {{ student.class_name }}</div>
                        </div>
                        <div class="student-status">
                            <van-tag :color="Object.keys(student.face_image_arr || {}).length > 0  ? '#DCFCE7' : '#FEF9C3'"
                                :text-color="Object.keys(student.face_image_arr || {}).length > 0  ? '#16A34A' : '#CA8A04'" round size="small"
                                class="face-status">
                                {{ Object.keys(student.face_image_arr || {}).length > 0  ? '已录脸' : '未录脸' }}
                            </van-tag>
                            <van-button v-if="Object.keys(student.face_image_arr || {}).length === 0 " type="primary" size="small" class="register-face-btn"
                                @click="registerFace(student)">
                                录入人脸
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 新增学生弹框 -->
            <AddStudentModal v-model:show="showAddStudentModal" @submit="handleAddStudent" />
            
            <!-- 底部充值按钮 -->
            <div class="bottom-recharge-section">
                <van-button type="primary" class="recharge-btn" block @click="handleRecharge">
                    立即充值
                </van-button>
            </div>
        </div>
    </PageLoading>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { setWxTitle } from '@/utils/wx'
import AddStudentModal from '@/components/AddStudentModal.vue'
import PageLoading from '@/components/PageLoading.vue'
import ErrorPage from '@/components/ErrorPage.vue'
import { WECHAT_APPID } from '../../../config/env'
import { post } from '@/utils/request'

onMounted(() => {
    setWxTitle('刷脸购买')
    loadStudents()
})

// 加载状态
const loading = ref(true)
// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')
// 处理错误
const handleError = (title, message) => {
    hasError.value = true
    errorTitle.value = title
    errorMessage.value = message
    loading.value = false
}
// 弹框显示状态
const showAddStudentModal = ref(false)

// 学生数据
const students = ref([])
const userDefaultImage = ref(localStorage.getItem('user_default_image'))
const faceNotice = ref('')

// 初始化微信授权
const initWechatAuth = () => {
    // 获取当前url中的code参数
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')

    // 判断用户取消授权
    const error = urlParams.get('error')
    const errorDesc = urlParams.get('error_description')
    if (error) {
        console.log('用户取消授权:', errorDesc)
        handleError('获取用户信息失败', errorDesc)
        return
    }

    if (!code) {
        // 如果没有code，重定向到微信授权页面
        const redirectUri = encodeURIComponent(window.location.href)
        const appId = WECHAT_APPID
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    } else {
        // 有code则获取用户信息
        getUserInfo({
            code: code,
            app_id: WECHAT_APPID,
            page_type: '首页'
        })
    }
}

// 获取用户信息
const getUserInfo = async (data) => {
    try {
        const res = await post('/api/index/info', data)

        if (res.result && res.result.state === 'ok') {
            const userInfo = res.result.partner_info || {}
            const accountInfo = res.result.account_info || {}
            // 存储用户ID到本地存储
            if (userInfo.id) {
                localStorage.setItem('userId', userInfo.id)
            }
            if (accountInfo.company_ids) {
                localStorage.setItem('company_ids', JSON.stringify(accountInfo.company_ids))
            }
            if (accountInfo.user_default_image) {
                localStorage.setItem('user_default_image', accountInfo.user_default_image)
                userDefaultImage.value = accountInfo.user_default_image
            }
            loadStudents()
        } else {
            handleError('获取用户信息失败', res.result?.message || '获取用户信息失败')
        }
    } catch (error) {
        console.error('获取用户信息失败:', error)
        handleError('获取用户信息失败', '获取用户信息失败，请重试')
    } finally {
        loading.value = false
    }
}

// 加载学生数据
const loadStudents = async () => {
    try {
        // 检查是否已有用户ID
        if (localStorage.getItem('userId')) {
            const res = await post('/api/index/info',{
                page_type: '刷脸购买',
                app_id: WECHAT_APPID,
                partner_id: parseInt(localStorage.getItem('userId')),
            })
            if (res.result && res.result.state === 'ok') {
                students.value = res.result.partner_info?.student_ids || []
                faceNotice.value = res.result.account_info?.face_buy_description || ''
            } else {
                handleError('加载失败', res.result?.message || '接口异常')
            }
            loading.value = false
        } else {
            initWechatAuth()
        }
    } catch (err) {
        console.error('加载学生数据失败:', err)
        handleError('加载失败', '获取学生列表失败')
        loading.value = false
    }
}

// 新增学生
const addStudent = () => {
    showAddStudentModal.value = true

}

// 处理新增学生提交
const handleAddStudent = async (formData) => {
    console.log('新增学生数据:', formData)
    loadStudents()
}

// 录入人脸
const registerFace = (student) => {
    console.log('录入人脸', student)
    // 这里可以跳转到录入人脸页面或打开弹窗
    window.location.href = '/face-recognition?partner_id=' + student.id
}

// 处理充值按钮点击
const handleRecharge = () => {
    console.log('点击立即充值')
    // 跳转到充值页面
    window.location.href = '/recharge'
}
</script>

<style scoped>
.face-purchase-page {
    background: #fff;
    min-height: calc(100vh - 94px);
    padding: 14px 14px 80px 14px;
}

.instructions-section {
    border-radius: 7px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    padding: 14px;
    margin-bottom: 21px;
}

.section-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 14px;
}

.instructions-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.instruction-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.instruction-icon {
    color: var(--van-primary-color);
    font-size: 16px;
}

.instruction-text {
    font-size: 12px;
    color: #4B5563;
    flex: 1;
}

.students-section {
    border-radius: 7px;
    padding: 14px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}

.students-section .section-title {
    margin-bottom: 0;
}

.add-student-btn {
    border: none;
    padding: 0;
}

.students-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.student-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
}

.student-avatar {
    flex-shrink: 0;
}

.student-avatar-img {
    width: 42px;
    height: 42px;
}

.student-info {
    flex: 1;
}

.student-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
}

.student-class {
    font-size: 14px;
    color: #666;
}

.student-status {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
}

.face-status {
    font-size: 12px;
    padding: 4px 8px;
}

.register-face-btn {
    border-radius: 7px;
    height: 24px;
}

/* 底部充值按钮样式 */
.bottom-recharge-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 16px 14px;
    border-top: 1px solid #f0f0f0;
    z-index: 100;
}

.recharge-btn {
    height: 48px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    border: none;
}
</style>